"use client";

import { sanitize } from "@litonarefin/utils/miscellaneous";
import { Fragment } from "react";
import styled from "styled-components";

export const BlogTitleSubtitle = ({ title = "", subTitle = "" }) => {
  return (
    <Fragment>
      <Title
        dangerouslySetInnerHTML={{
          __html: sanitize(title || ""),
        }}
      />
      {subTitle ? (
        <Subtitle
          dangerouslySetInnerHTML={{
            __html: sanitize(subTitle || ""),
          }}
        />
      ) : null}
    </Fragment>
  );
};

const Title = styled.h3.attrs((props) => ({
  className:
    "jlt-author-name jlt-text-3xl sm:jlt-text-4xl md:jlt-text-5xl jlt-text-center jlt-text-[#1D2939]",
}))`
  > span {
    color: var(--primary);
  }
`;

const Subtitle = styled.p.attrs((props) => ({
  className: "jlt-text-lg md:jlt-text-xl jlt-leading-8 jlt-text-center jlt-mt-2 jlt-font-semibold",
}))`
  > span {
    color: var(--primary);
  }
`;
